import PercentageRangeSlider from 'components/PercentageRangeSlider/Index'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledHeading = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  margin: 15px;
  color: ${props => (props.color ? props.color : COLORS.BLACK)};
`

const CandidateRatingFilter = ({
  setCandidateRating,
  candidateRating,
  labelText,
}) => {
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(5)
  const onMinValueChange = val => {
    setMinValue(val)
    setCandidateRating({ minValue: val, maxValue })
  }
  const onMaxValueChange = val => {
    setMaxValue(val)
    setCandidateRating({ minValue: minValue, maxValue: val })
  }
  // useEffect(() => {
  //   setCandidateRating({ minValue: minValue, maxValue: maxValue })
  // }, [minValue, maxValue])
  return (
    <>
      <StyledHeading>{labelText || ' Candidate Rating'}</StyledHeading>
      <StyledHeading color={COLORS.BLACK_WHITE_B_50}>
        {minValue} - {maxValue}
      </StyledHeading>

      <PercentageRangeSlider
        minValue={minValue}
        setMinValue={onMinValueChange}
        maxValue={maxValue}
        setMaxValue={onMaxValueChange}
      />
    </>
  )
}

export default CandidateRatingFilter
